import React, {Component} from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import TableContainer from '@mui/material/TableContainer'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Receipt as ReceiptIcon,
} from '@mui/icons-material';



const session = require('../../config/session')

function Row(props) {
 const {evento} = props;
 const [open, setOpen] = React.useState(false)
 let image = ""

  switch (evento.tipo_evento) {
    case "I":
      image = "/img_event_informativo.png";
      break;
    case "O":
      image = "/img_event_operativo.png";
      break;
    case "E":
      image = "/img_event_error.png"; 
      break;
    default:
      image = "/img_event_informativo.png";
      break;

  }

 var detalle = (evento.detalle !== '' ? JSON.parse(evento.detalle) : '')
 var filaDetalle = []

 const renderTablaMoneda = (items, tipo, total) => (
  <Box sx={{ my: 2 }}>
    <Typography variant="subtitle2" sx={{ mb: 1 }}>{tipo}:</Typography>
    <Table size="small" sx={{ mb: 2, border: '1px solid #e0e0e0' }}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontWeight: 'bold' }}>Denominacion</TableCell>
          <TableCell sx={{ fontWeight: 'bold' }}>Cantidad</TableCell>
          <TableCell sx={{ fontWeight: 'bold' }}>Subtotal</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((item, i) => (
          <TableRow key={i}>
            <TableCell>{parseInt(item.denomination).toLocaleString()}</TableCell>
            <TableCell>{item.amount}</TableCell>
            <TableCell>
              ${(item.denomination * item.amount).toLocaleString()}
            </TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell sx={{ fontWeight: 'bold' }}>Total</TableCell>
          <TableCell />
          <TableCell sx={{ fontWeight: 'bold' }}>
            ${total.toLocaleString()}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </Box>
)

for (const campo in detalle) {
  if (campo === 'detalle_boveda') {
    const detalleBovedaObj = detalle[campo]
    
      const tipoDetalle = 'automatico'
      const tipo = 'Automático' 
      const currencies = detalleBovedaObj[tipoDetalle].currencies

      const contenido = currencies.map((currency, idx) => (
        <Box key={idx} sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Moneda País: {currency.currency}</Typography>
          {renderTablaMoneda(currency.bills, 'Billetes', currency.total_bills)}
        </Box>
      ))

      filaDetalle.push(
        <TableRow key={tipo}>
          <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'action.selected' }}>{tipo}</TableCell>
          <TableCell>{contenido}</TableCell>
        </TableRow>
      )
    
  } else if (campo !== 'uid_usuario_autorizo') {
    filaDetalle.push(
      <TableRow key={campo}>
        <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'action.selected' }}>{campo}</TableCell>
        <TableCell>{JSON.stringify(detalle[campo])}</TableCell>
      </TableRow>
    )
  }
}

 return (
   <React.Fragment>
     <TableRow>
      <TableCell>
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
        >
          {open ? <KeyboardArrowUpIcon />:<KeyboardArrowDownIcon />}
        </IconButton>
      </TableCell>
       <TableCell>
         <img alt='x' src={image} style={{width: 24}}/>
       </TableCell>
       <TableCell>
         {evento.fecha_registro} 
       </TableCell>
       <TableCell>
        {
          evento.codigo_cajero
        }
       </TableCell>
       <TableCell>
         {evento.alias_cajero}
       </TableCell>
       <TableCell>
         {evento.tipo_evento}
       </TableCell>
       <TableCell>
         {evento.id_evento}
       </TableCell>
       <TableCell>
         {evento.codigo_evento}
       </TableCell>
     </TableRow>
     <TableRow>
     </TableRow>
     <TableRow>
      <TableCell style={{paddingTop: 0, paddingBottom: 0}} colSpan={10}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box mb={4} mt={4}>
            <Box display="flex" alignItems="center" mb={2} sx={{ mr: 5 }}>
              <ReceiptIcon color="primary" sx={{ mr: 1 }} />
              <Typography variant="subtitle1" fontWeight="bold">
                Detalles del evento
              </Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />

            <Table size="small" sx={{
              '& th': {
                backgroundColor: 'action.selected',
                fontWeight: 'bold'
              },
              '& td, & th': {
                py: 1,
                px: 2,
                verticalAlign: 'top'
              }
            }}>
              <TableBody>
                {filaDetalle}
              </TableBody>
            </Table>
          </Box>
        </Collapse>
      </TableCell>
     </TableRow>
   </React.Fragment>
 );
}

function RowBilletes(billetes) {
  /* eslint-disable no-redeclare */
  var billetes = billetes.split(',')
  /* eslint-enable no-redeclare */

  var filasBilletes = []
  for(var billete in billetes) {
    filasBilletes.push(
      <TableRow>
       <TableCell className="sub-detalle-valor">{billetes[billete]}</TableCell>
      </TableRow>
    )
  }

  return(
    <Table>
      {filasBilletes}
    </Table>
  )
}


class EventosTable extends Component {

  constructor(props) {
    super(props)

    this.state = {
      eventos: []
    }



  }


  componentDidMount() {
  }

  render() {

    var eventos = this.props.eventos

    const columns = [
      {field: "desplegable", headerName: "", width: 10},
      {field: "tipo_icono", headerName: "", width: 10},
      {field: "fecha_hora", headerName: 'Fecha Registro', width: 150},
      {field: "codigo_cajero", headerName: 'Codigo Cajero', width: 150},
      {field: "alias_cajero", headerName: 'Alias Cajero', width: 170},
      {field: "tipo_evento", headerName: 'Tipo', width: 50},
      {field: "id_evento", headerName: 'ID Evento', width: 100},
      {field: "codigo_evento", headerName: 'Codigo Evento', width: 150},
    ]

    return (
      <Paper sx={{ 
        width: '100%',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        mb: 3
      }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'fontWeightBold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2
                  }
                }}>
                {columns.map((column) => {
                  return(
                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {eventos.map((evento, idx) => {
                return(
                  <Row key={idx} evento={evento} />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }
}

export default EventosTable;
